import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import { ProtocolVisitsState, ProtocolVisitsUnloadState } from '../states/ProtocolVisitsState';

type KnownAction =
    | Actions.ProtocolVisits.ProtocolVisitsExportExcelRequestAction
    | Actions.ProtocolVisits.ProtocolVisitsExportExcelSuccessAction
    | Actions.ProtocolVisits.ProtocolVisitsExportExcelFailureAction;

export const ProtocolVisitsReducer: Reducer<ProtocolVisitsState> = (
    state: ProtocolVisitsState | undefined,
    incomingAction: Action
): ProtocolVisitsState => {
    if (state === undefined) {
        return ProtocolVisitsUnloadState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'PROTOCOLVISITS_EXPORT_EXCEL_REQUEST':
            return {
                ...state,
                isLoading: true,
                isGeneratedSuccessfully: false,
                failOnGenerating: false,
                error: null,
                excelBlob: null
            };

        case 'PROTOCOLVISITS_EXPORT_EXCEL_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isGeneratedSuccessfully: true,
                failOnGenerating: false,
                excelBlob: action.excelBlob,
                error: null
            };

        case 'PROTOCOLVISITS_EXPORT_EXCEL_FAILURE':
            return {
                ...state,
                isLoading: false,
                isGeneratedSuccessfully: false,
                failOnGenerating: true,
                error: action.error,
                excelBlob: null
            };

        default:
            return state;
    }
};
